import uiRouter from 'angular-ui-router';

angular.module('navigation', [
    uiRouter
  ])
  .service('navigationManager', ['$state', '$stateParams', '$rootScope', '$window',
    function ($state, $stateParams, $rootScope, $window) {
      let map = {};

      this.registerViewComponent = (controller, $scope, state) => {
        console.log('Registering', controller);

        map[state] = map[controller.name] = {
          controller: controller,
          $scope: $scope,
          state: state
        };

        $scope.$on('focus', (event, obj) => {
          //console.log(" event:", event);
          //console.log("obj:", obj);
          if (obj.id === state) {
            controller.focus();
          }
        });
      };

      this.registerNavigate = (elementId, direction, callbackOrId) => {
        let el = document.getElementById(elementId);

        //console.log("element in registernavigate:", el);
        if (el) {
          el.addEventListener('keydown', event => {
            //console.log("i m coming here", event);
            let hit = false;

            //console.log('Button', direction, event.code);
            switch (direction) {
              case 'up':
                if (event.code === 'ArrowUp' || event.keyIdentifier === 'Up') {
                  hit = true;
                }
                break;
              case 'down':
                if (event.code === 'ArrowDown' || event.keyIdentifier === 'Down') {
                  hit = true;
                }
                break;
              case 'right':
                if (event.code === 'ArrowRight' || event.keyIdentifier === 'Right') {
                  hit = true;
                }
                break;
              case 'left':
                if (event.code === 'ArrowLeft' || event.keyIdentifier === 'Left') {
                  hit = true;
                }
                break;
            }

            if (hit) {
              if (typeof callbackOrId === 'function') {
                callbackOrId();
              } else if (typeof callbackOrId === 'string') {
                document.getElementById(callbackOrId).focus();
              }

              event.preventDefault();
            }
          });
        } else {
          console.error('Could not find element by id:', elementId);
        }
      };

      $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => {
        let cancel = $rootScope.$on('$viewContentLoaded', _ => {
          let navItem = map[toState.name];

          //console.log("fromState:", fromState);
          //console.log("toState:", toState);
          /*if(fromState.name === 'home.landingpage.viewpaybilllanding' && toState.name === 'home.landingpage'){
            console.log("$window:",$window.history);
            //$window.history.go(1);
            //window.location.replace('');
            event.preventDefault();
            //$state.go(toState, {}, { location: 'replace' });
          }*/

          if (toState.redirectTo) {
            event.preventDefault();
            $state.go(toState.redirectTo, {location: 'replace'});
          }

          //console.log("toState.redirectTo:", toState.redirectTo);

          if (navItem) {
            //navItem.controller.focus();
          } else if(toState.redirectTo === undefined){
            //console.error('Controller could not be found', toState, map);
          }

          cancel();
        });
      });
    }]);



// WEBPACK FOOTER //
// ./client/app/navigation/navigation.js